import React from 'react';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import PulseLoader from "react-spinners/PulseLoader";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import Cookies from 'js-cookie';
import { CheckSession } from "../../GlobalScript";
export default function OrderStep2() {
 //   const navigate = useNavigate();
 //   const [UserInfo, setUserInfo] = useState(null);
 //   const [Loading, setLoading] = useState(true);
	//useEffect(() => {
	//	debugger;
 //       if (Loading) {
 //           setLoading(false);
 //       }
 //   }, [Loading])
	useEffect(() => {
		CheckSession();
	})

    return (
        <>
            <Container className="checkout-container main-container">
                <Row className="checkout-title-row">

                    <Col className="checkout-title">
                        <Card.Title className="vertical-line heading card-main-title active-heading" role="heading">New Order</Card.Title>
                    </Col>

                    <Table>
						<tbody>
							<tr>
								<td colspan="15">
									<hr />
								</td>
							</tr>

							<tr>
								<td colspan="15" align="Center" nowrap=""><font size="5"><b>
									Order Name:
									202502281554 <br />
									Order Type: Regular
								</b></font>
								</td>
							</tr>

							<tr>
								<td colspan="15"><hr /></td>
							</tr>

							<tr align="center">
								<td class="ColumnHeader">
									<b>Item Number</b>
								</td>

								<td class="ColumnHeader">
									<b></b>
								</td>
								
								<td class="ColumnHeader">
									<b>Inventory Type</b>
								</td>

								<td class="ColumnHeader">
									<b>Order Qty</b>
								</td>
								<td colspan="4" class="ColumnHeader">
									<b>Available<b>
									</b></b>
								</td>

								<td class="ColumnHeader">
									<b>Bkord Qty</b>
								</td>

								<td class="ColumnHeader" nowrap="">
									<b>Memo</b>
								</td>

								<td class="ColumnHeader">
									<b>Pkg Qty</b>
								</td>

								<td class="ColumnHeader">
									<b>Unit Price</b>
								</td>

								<td class="ColumnHeader">
									<b>Item Total</b>
								</td>

								<td class="ColumnHeader" colspan="1">
									<b>Emergency<br />Order</b>
								</td>

								<td nowrap="" align="center" class="ColumnHeader">
									<b>0 Line(s) in cart</b>
								</td>
							</tr>

							<tr>
								<td class="TableDataLight">
									<input name="NIN0" id="NIN0" size="15" maxlength="20" />
								</td>

								<td class="TableDataLight">
									&nbsp;
								</td>
								<td class="TableDataLight">&nbsp;</td>
								<td class="TableDataLight"><input name="NIM0" id="NIM0" SIZE="7" /></td>
								<td class="TableDataLight">
									<input TYPE="checkbox" name="NewItemEmergency0" id="NewItemEmergency0" VALUE="E" />
								</td>
								<td class="TableDataLight">
									&nbsp;
								</td>

								<td class="TableDataLight">
									<input name="NIQ0" id="NIQ0" size="3" maxlength="3" onblur="javascript: ValidateQty(this)" />
								</td>
								<td class="TableDataLight">
									&nbsp;
								</td>
								<td class="TableDataLight">
									<input name="NIM0" id="NIM0" size="7" maxlength="7" onblur="javascript: ValidateMemo(this);" />
								</td>
								<td class="TableDataLight">
									&nbsp;
								</td>
								<td class="TableDataLight">
									&nbsp;
								</td>
								<td class="TableDataLight">
									&nbsp;
								</td>
								<td class="TableDataLight">
									&nbsp;
								</td>
								<td class="TableDataLight" align="center">
									<input type="checkbox" name="NIE0" id="NIE0" value="E" disabled="" onblur="javascript: ValidateEmergency(this);" />
								</td>

								<td class="TableDataLight">
									<a href="#"></a>
									<input type="button" class="KMCButton" id="btnAddItem" name="btnAddItem" value="Add To Cart" onclick="" />

								</td>
							</tr>

							<tr>
								<td colspan="15"><hr /></td>
							</tr>
						</tbody>
					</Table>
				</Row>
			</Container>
        </>
    );
}